import frCharles from './dictionaries/fr.json'
import frMia from './dictionaries/fr-mia.json'

import { IS_CHARLES_PLATFORM } from 'constants/config'

export default {
  fr: (IS_CHARLES_PLATFORM ? frCharles : frMia)
}
